module.exports = __webpack_public_path__ + "./favicons/ms-icon-144x144.png";